import { Grid } from "@mui/material";
import { doctoralRequests } from "api/doctoralApi";
import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
  required,
} from "react-admin";

const SaveForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ReferenceInput
          source="parentId"
          reference={doctoralRequests.getDoctoralDisciplinesSelect()}
        >
          <AutocompleteInput
            label="Главна дисциплина"
            optionText="name"
            fullWidth
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
